// cubic-bezier как функция t → прогресс — для react-spring, чтобы числа шли той же кривой, что и CSS-переходы (MOTION.easing)
export function cubicBezier(x1, y1, x2, y2) {
  const bezier = (t, p1, p2) => 3 * (1 - t) * (1 - t) * t * p1 + 3 * (1 - t) * t * t * p2 + t * t * t;
  const slope = (t, p1, p2) => 3 * (1 - t) * (1 - t) * p1 + 6 * (1 - t) * t * (p2 - p1) + 3 * t * t * (1 - p2);
  return (x) => {
    if (x <= 0) return 0;
    if (x >= 1) return 1;
    // t по x — методом Ньютона, кривая монотонна по x
    let t = x;
    for (let i = 0; i < 8; i += 1) {
      const d = slope(t, x1, x2);
      if (Math.abs(d) < 1e-6) break;
      t -= (bezier(t, x1, x2) - x) / d;
      t = Math.min(1, Math.max(0, t));
    }
    return bezier(t, y1, y2);
  };
}

export const motionEasing = cubicBezier(0.2, 0.8, 0.2, 1);
